
import React from 'react';
import { FaEye, FaChartLine, FaUserGraduate, FaPiggyBank, FaExclamationTriangle, FaCogs, FaRocket, FaLightbulb, FaCalculator, FaShieldAlt, FaTools } from "react-icons/fa";
import { MdOutlineReportGmailerrorred } from "react-icons/md";
import { PiPath } from "react-icons/pi";

const TipCard = ({ icon, title, children }) => (
    <div className="p-4 rounded-4 h-100" style={{ background: '#2c2c2c' }}>
        <div className="d-flex align-items-center mb-3">
            <div className="me-3 text-primary" style={{ fontSize: '2rem' }}>{icon}</div>
            <h4 className="font1 fw-bold mb-0">{title}</h4>
        </div>
        <div>{children}</div>
    </div>
);

const TipsAndTricks = ({ setShowTips }) => {
    return (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: 'rgba(0, 0, 0, 0.9)', zIndex: 1050 }}>
            <div className="text-white rounded-4 p-4" style={{ width: '95%', maxWidth: '1400px', height: '95vh', background: '#1a1a1a', overflowY: 'auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-5 pb-3 border-bottom border-secondary">
                    <div className='d-flex align-items-center'>
                        <FaLightbulb className='text-primary me-3' size='2.5rem'/>
                        <h1 className="font1 fw-bold mb-0">Tipy a Triky pre Live Arbitráž</h1>
                    </div>
                    <button onClick={() => setShowTips(false)} className="btn-close btn-close-white" style={{transform: 'scale(1.5)'}}></button>
                </div>

                <div className="row g-4 mb-5">
                    <div className="col-lg-4">
                        <TipCard icon={<FaRocket />} title="Prečo Live Arbitráž?">
                            <p>Live stávkovanie ponúka jedinečné výhody:</p>
                            <ul>
                                <li><strong>Viac príležitostí:</strong> Kurzy sa menia rýchlo, čo generuje oveľa viac arbitráží v porovnaní s predzápasovým stávkovaním.</li>
                                <li><strong>Vyššie zisky:</strong> Nie je nezvyčajné nájsť arbitráže so ziskom 10% a viac.</li>
                                <li><strong>Nižšie riziko limitácie:</strong> Stávkové kancelárie majú menej času na analýzu vašich stávok, čo znižuje riziko obmedzenia účtu.</li>
                                <li><strong>Rýchla návratnosť kapitálu:</strong> Keďže zápasy končia rýchlo, svoj kapitál (bankroll) môžete otočiť viackrát za deň.</li>
                            </ul>
                        </TipCard>
                    </div>
                    <div className="col-lg-4">
                        <TipCard icon={<FaUserGraduate />} title="Základy pre Začiatočníkov">
                            <p>Ak s live arbitrážou začínate, držte sa týchto pravidiel:</p>
                            <ul>
                                <li><strong>Začnite s málom:</strong> Vyberte si 2-3 stávkové kancelárie, ktorým dobre rozumiete.</li>
                                <li><strong>Jednoduchšie športy:</strong> Začnite so športmi, kde sa kurzy menia menej často, ako futbal.</li>
                                <li><strong>Malé vklady:</strong> Stávkujte zo začiatku menšie sumy, aby ste získali prax bez veľkého rizika.</li>
                                <li><strong>Trpezlivosť:</strong> Čakajte na príležitosti, ktoré sú aktívne aspoň 20-30 sekúnd.</li>
                            </ul>
                        </TipCard>
                    </div>
                    <div className="col-lg-4">
                        <TipCard icon={<FaExclamationTriangle />} title="Riziká a Rady">
                            <p>Na čo si dať pozor:</p>
                            <ul>
                                <li><strong>Nestihli ste stávku?</strong> Okamžite použite cash out. Malá strata je lepšia ako riskovať celý vklad.</li>
                                <li><strong>Pravidlá:</strong> Naštudujte si pravidlá stávkových kancelárií (napr. skreč v tenise).</li>
                                <li><strong>Posledné minúty:</strong> Vyhnite sa stávkam v posledných minútach zápasu.</li>
                            </ul>
                        </TipCard>
                    </div>
                </div>

                <div className="row g-4 mb-5">
                    <div className="col-12">
                        <TipCard icon={<FaCogs />} title="Tipy pre Jednotlivé Športy">
                            <div className="row g-3 mt-2">
                                <div className="col-md-4">
                                    <h5>🏀 Basketbal</h5>
                                    <ul>
                                        <li>Najlepšie je podávať počas prestávok, timeoutov alebo iných prerušení hry.</li>
                                        <li>Stávkové kancelárie často vypínajú kurzy 3 minúty pred koncom štvrtiny a polčasové body po prvej štvrtine.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <h5>🎾 Tenis</h5>
                                    <ul>
                                        <li>Podávajte pred začiatkom zápasu, počas prestávok po nepárnych gemoch alebo medzi setmi.</li>
                                        <li>Nikdy nepodávajte počas aktívnej hry – kurzy sa menia extrémne rýchlo.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <h5>⚽ Futbal</h5>
                                    <ul>
                                        <li>Stávky môžete podávať aj počas hry, ale buďte pripravení na rýchle zmeny kurzov.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <h5>🏒 Hokej</h5>
                                    <ul>
                                        <li>Pri stávkach na góly, víťaza zápasu alebo tretiny môžete podávať počas hry.</li>
                                        <li>Vylúčenie hráča (presilovka) dramaticky mení kurzy. V takom prípade podajte najprv stávku "viac ako" (napr. 5.5 gólu) a až potom "menej ako", aby ste sa vyhli strate pri rýchlom góle.</li>
                                        <li>Pozor, 2-3 minúty pred koncom alebo pri odvolaní brankára sa kurzy často vypínajú.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <h5>🏐 Volejbal</h5>
                                    <ul>
                                        <li>Kurzy sa menia veľmi rýchlo. Stávkujte počas technických timeoutov alebo medzi setmi.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <h5>🤾‍♂️ Hádzaná</h5>
                                    <ul>
                                        <li>Podobne ako pri hokeji, kurzy sa rýchlo menia. Stávkujte počas polčasovej prestávky alebo pri prerušení hry.</li>
                                    </ul>
                                </div>
                            </div>
                        </TipCard>
                    </div>
                </div>

                <div className="row g-4">
                    <div className="col-12">
                        <TipCard icon={<FaTools />} title="Ako Používať Softvér">
                            <p className='text-white-50'>Prehľad funkcií, ktoré vám pomôžu maximalizovať zisk:</p>
                            <div className="row g-4 mt-3">
                                <div className="col-lg-4">
                                    <h5 className="font1 text-primary">Filtre a Upozornenia</h5>
                                    <ul>
                                        <li><strong>Filtrovať ponuku:</strong> Tu si nastavíte, ktoré stávkové kancelárie, športy, minimálne ROI (%) a minimálnu dobu trvania arbitráže chcete zobrazovať.</li>
                                        <li><strong>Upozorniť:</strong> Nastavte si zvukové a svetelné upozornenia. Svetelné upozornenie (žltý rámik) sa aktivuje, ak je arbitráž aktívna dlhšie ako nastavený počet sekúnd. Zvukové upozornenie vás notifikuje o nových príležitostiach spĺňajúcich vaše kritériá (ROI a doba trvania).</li>
                                    </ul>
                                </div>
                                <div className="col-lg-4">
                                    <h5 className="font1 text-primary">Analytické Nástroje</h5>
                                    <ul>
                                        <li><strong>Top zápasy:</strong> Zobrazí zápasy s najväčším počtom arbitráží podľa vašich filtrov. Pomôže vám to zamerať sa na najhorúcejšie príležitosti.</li>
                                        <li><strong>Štatistiky:</strong> Grafy zobrazujú priemerný počet zápasov a arbitráží v jednotlivých hodinách. Využite tieto dáta na identifikáciu najlepšieho času na stávkovanie.</li>
                                        <li><strong>Vyhľadať zápas:</strong> Nájdite konkrétny zápas a sledujte všetky dostupné arbitrážne príležitosti preň.</li>
                                    </ul>
                                </div>
                                <div className="col-lg-4">
                                    <h5 className="font1 text-primary">Riadok Arbitráže a Ikonky</h5>
                                    <p>Každý riadok predstavuje jednu arbitrážnu príležitosť. Tu sú kľúčové prvky:</p>
                                    <ul>
                                        <li><strong>Kalkulačka:</strong> Do políčka vkladu zadajte sumu pre jednu stranu a druhá sa automaticky prepočíta, aby ste videli garantovaný zisk.</li>
                                        <li><FaEye size="1.3em" className="me-2" /> <strong>Sledovať zápas:</strong> Otvorí detail zápasu.</li>
                                        <li><MdOutlineReportGmailerrorred size="1.4em" className="me-2" /> <strong>Nahlásiť chybu:</strong> Nahlási nesprávne spárovaný zápas.</li>
                                        <li><PiPath size="1.4em" className="me-2" /> <strong>Skopírovať cestu:</strong> Skopíruje názov stávkového trhu.</li>
                                    </ul>
                                </div>
                            </div>
                        </TipCard>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TipsAndTricks;
